import { useState, useRef, useEffect, useCallback } from 'react';
import { copyToClipboard } from '../utils';

export const useLogs = () => {
  const [logs, setLogs] = useState([]);
  const [copySuccess, setCopySuccess] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const logContainerRef = useRef(null);

  const addLog = useCallback((message, type = 'info') => {
    const timestamp = new Date().toLocaleTimeString();
    setLogs(prevLogs => [...prevLogs, { timestamp, message, type }]);
  }, []);

  const clearLogs = () => {
    setLogs([]);
  };

  const copyLogs = async () => {
    const logText = logs.map(log => `[${log.timestamp}] [${log.type}] ${log.message}`).join('\n');
    try {
      await copyToClipboard(logText);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (error) {
      console.error('Failed to copy logs:', error);
    }
  };

  useEffect(() => {
    if (logContainerRef.current && showLogs) {
      logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
    }
  }, [logs, showLogs]);

  return {
    logs,
    showLogs,
    copySuccess,
    logContainerRef,
    addLog,
    clearLogs,
    copyLogs,
    setShowLogs
  };
};